import { ValueWithLabel } from "../types";

export function getAutocompleteFieldValue(
  list: ValueWithLabel[],
  value: string | null | undefined
): ValueWithLabel | null {
  return list.find((item) => item.value === value) ?? null;
}
